import { BadgeCheck, Handshake, Leaf, ThumbsUp } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Leaf, title: "Quality Workmanship", text: "Every project, large or small, gets careful, professional attention." },
  { icon: ThumbsUp, title: "Customer Satisfaction", text: "Quality work at fair prices — reliable crews that show up and finish the job." },
  { icon: Handshake, title: "Personalized Property Care", text: "Care plans shaped around your property, not a one-size-fits-all package." },
  { icon: BadgeCheck, title: "Free On-Site Estimates", text: "We visit your property, evaluate your needs, and quote — at no charge." },
];

export default function About({ content }) {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <span className="text-brand font-bold uppercase tracking-widest text-sm">About Us</span>
          <h2 className="mt-3 font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Residential &amp; Commercial Landscaping You Can Count On
          </h2>
          <div className="mt-5 h-1.5 w-24 bg-brand rounded-full" aria-hidden="true" />
          <p className="mt-6 text-[#4B5563] text-lg leading-relaxed" data-testid="about-text">
            {content?.about_text}
          </p>
          <p className="mt-4 text-[#4B5563] leading-relaxed">
            Serving the <strong className="text-forest">{content?.service_area || "Dallas / DFW metro area"}</strong> —
            from routine lawn care to complete landscape design, our team delivers personalized care
            for every property we maintain.
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {HIGHLIGHTS.map((item) => (
              <div key={item.title} className="flex gap-3">
                <span className="shrink-0 w-10 h-10 rounded-full bg-brand-light flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-brand" aria-hidden="true" />
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-ink text-base">{item.title}</h3>
                  <p className="text-sm text-[#4B5563] mt-1 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-3 bg-brand-light rounded-2xl" aria-hidden="true" />
          <img
            src="/assets/truck.jpg"
            alt="Somoza's Landscaping branded work truck at a job site"
            className="relative rounded-2xl shadow-md w-full object-cover aspect-[4/3]"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
